import { useMemo } from "react";
import { useParams } from "react-router";

import { PageContent, PageHeader, TabContent } from "components/layout";
import { useClientType } from "hooks/tivoDevices";

import { TiVoDeviceAppsList } from "./components/TiVoDeviceAppsList";
import { TiVoDeviceTabs } from "./components/TiVoDeviceTabs";
import { getClientTypeTabs } from "./utils";

export function TiVoClientTypeApplications() {
  const { platformId, oemId, clientTypeId } = useParams();
  const { data } = useClientType(platformId, oemId, clientTypeId);
  const clientType = useMemo(() => data?.results, [data?.results]);

  return (
    <>
      <PageHeader>{clientType?.name || ""}</PageHeader>
      <PageContent>
        <TiVoDeviceTabs
          tabs={getClientTypeTabs(platformId, oemId, clientTypeId)}
        />
        <TabContent>
          <TiVoDeviceAppsList
            platformId={platformId!} // We can non-null assert because this parameter is in the path
            oemId={oemId!} // We can non-null assert because this parameter is in the path
            clientTypeId={clientTypeId}
          />
        </TabContent>
      </PageContent>
    </>
  );
}
